// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1LinkedWorkItemsCreateSchema = z.object({
  linked_work_item: z.object({
    title: z.coerce.string().min(1).max(500),
    external_code: z.coerce.string().max(64).nullish(),
    url: z.coerce.string().max(2048).nullish(),
    description: z.coerce.string().max(16000).nullish(),
    source_name: z.coerce.string().max(64).nullish(),
    icon_url: z.coerce.string().max(1024).nullish(),
    project_id: z.number().int().nullish(),
    assigned_user_id: z.number().int().nullish(),
    start_date: z.string().date().nullish(),
    due_date: z.string().date().nullish(),
    completed_at: z.string().datetime().nullish(),
    external_id: z.coerce.string().min(1).max(128),
  }),
});
